import { isKeyCodeNumber, isKeyCodeNumpadNumber, isSpecialKey } from '@panel/commons/helpers/keyUtils';

function specialCharactersLock(evt) {
  const code = evt.which ? evt.which : evt.keyCode;
  if (!(isSpecialKey(code) || isKeyCodeNumber(code) || isKeyCodeNumpadNumber(code))) {
    evt.preventDefault();
  }
  if (evt.shiftKey || evt.ctrlKey || evt.altKey) {
    evt.preventDefault();
  }
}

const calculatePriceWithTax = (priceString, symbol, siteId) => {
  if (!priceString) return '';

  // Si no es Argentina, devolvemos sin modificaciones
  if (siteId !== 'ZPAR') {
    return `${symbol} ${priceString}`;
  }

  const normalizedPrice = priceString
    .replace(/\./g, '') // Quitamos separador de miles
    .replace(',', '.'); // Convertimos coma decimal a punto

  const price = parseFloat(normalizedPrice);

  if (Number.isNaN(price)) return '';

  const ARGENTINIAN_TAX_RATE = 0.21;
  const priceWithTax = price * (1 + ARGENTINIAN_TAX_RATE);

  // Convertimos de vuelta a formato argentino
  const formattedPrice = priceWithTax
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${symbol} ${formattedPrice}`;
};

export { specialCharactersLock, calculatePriceWithTax };
